import { render, staticRenderFns } from "./NonConformityCauseForm.vue?vue&type=template&id=c8a1ef34&scoped=true&"
import script from "./NonConformityCauseForm.vue?vue&type=script&lang=js&"
export * from "./NonConformityCauseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a1ef34",
  null
  
)

export default component.exports